import {Box, Grid} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import useWindowSize from 'hooks/useWindowSize';
import Unauthorized from 'pages/Unauthorized';
import LoadingPage from './LoadingPage';
import {CloudErrorPage} from './LoadingPage';

const useStyles = makeStyles(theme => ({
    containedContent: {
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        [theme.breakpoints.up('sm')]: {
            width: '600px',
        },
        [theme.breakpoints.up('md')]: {
            width: '700px',
        },
        [theme.breakpoints.up('lg')]: {
            width: '1000px',
        },
    },
    uncontainedContent: {
        height: '100%',
    },
    containedItem: {},
}));

const PageTab = ({
    contained = true,
    gridContainer = true,
    spacing = 2,
    isLoading = false,
    error = null,
    unauthorized = false,
    children,
    ...gridProps
}) => {
    const {width} = useWindowSize();
    const calcSpacing = spacing !== 'dynamic'
                            ? spacing
                            : width < 960 
                                ? width < 768
                                    ? 0
                                    : 2 
                                : 3;
    const classes = useStyles();

    if (isLoading !== false) {
        return <LoadingPage message='Fetching Data' />;
    } else if (error) {
        return <CloudErrorPage error={error} />;
    } else if (unauthorized) {
        // TODO: UnauthorizedPage is on other branch. Merge in other branch to put up correct component
        return (
            <Unauthorized
                message='Either this page is currently unavailable or you are unauthorized to access it.
            Please check the URL and try again.'
            />
        );
    } else {
        return (
            <Grid
                container
                className={
                    contained
                        ? classes.containedContent
                        : classes.uncontainedContent
                }
                spacing={calcSpacing}
                {...gridProps}
            >
                {children}
            </Grid>
        );
    }
};

const ContainedPageItem = ({children}) => {
    const classes = useStyles();
    return <Box className={classes.containedItem}>{children}</Box>;
};

export default PageTab;
export {ContainedPageItem};
